import React, { useState } from "react";
import axios from "axios";
import { useUser } from "../../context/userContext";
import NewsLetterBox from "./newsLetterBox";
import { saveAs } from 'file-saver'
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import ReactCountryDropdown from "react-country-dropdown";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const moment = require("moment");


const VCardComponent = () => {

  const [imageData, setImageData] = useState(null);
  const [downloaded, setDownloaded] = useState();


  const Navigate = useNavigate();

  const { userData } = useUser();

  const [isContentLoading, setIsContentLoading] = useState(false);

  const initialFormData = {
    email:"",
    first_name:"",
    last_name:"",
    website:"",
    organization_name:"",
    country_code:"91",
    mobile_number:"",
    alt_country_code:"91",
    alt_mobile_number:"",
    alt_email:"",
    work_address:"",
    dob:"",
    home_address:"",
    designation:"",
    linkedin_profile:"",
    fb_profile:"",
    twitter_profile:"",
    pronouns:""
  };

  const [formData, setFormData] = useState(initialFormData);

  const validateMobileNumber = (mobileNumber) => {
    const mobileNumberRegex = /^[0-9]{10}$/;
    return mobileNumberRegex.test(mobileNumber);
  };

  // const validateEmail = (email) => {
  //   const emailRegex = /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9._:$!%-]+.[a-zA-Z]$/;
  //   return emailRegex.test(email);
  // };

  const handleSubmitTicket = async (event) => {
    event.preventDefault();

    if (!validateMobileNumber(formData.mobile_number)) {
      alert("Please enter a valid 10-digit mobile number.");
      return;
    }

    // if(!validateEmail(formData.email)){
    //   alert("Please enter a valid Email ID.");
    //   return;
    // }


    try {

      setIsContentLoading(true);

      const response = await axios.post(
        "https://soliboat.solidaridadasia.com/vcard_details",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData.token}`,
          },
          withCredentials: true,
          responseType: 'blob'
        }
      );

      const url = URL.createObjectURL(response.data);
        
      setImageData(url);

      if (response.status === 200) {
        const data = response.data;
        alert(data.message[0]);
        setFormData(initialFormData);
      } else {
        console.error("Error submitting ticket:", response.statusText);
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    } finally {
      setIsContentLoading(false);
    }
  };

  // console.log(imageData)
  
  // const handleSubmit = () => {
    
  //   const myHeaders = new Headers();
  //   myHeaders.append("Content-Type", "application/json");

  //   const raw = JSON.stringify({
  //     "email": email,
  //     // "name": name,
  //     "website": website,
  //     "organization_name": company,
  //     "mobile_number": phone,
  //     "address": address,
  //     "designation": designation,
  //   });

  //   const requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: raw,
  //     redirect: "follow",
  //   };

  //   const fetchData = async()=>{
  //     try{
  //       const res = await fetch(`https://soliboat.solidaridadasia.com/vcard_details`, requestOptions);
  //       const blob = await res.blob();
  //       const url = URL.createObjectURL(blob)
        
  //       setImageData(url);
  
  //     }catch(e){
  //       console.log(`Error: ${e}`)
  //     }
  //   }
  //   fetchData()
  // };

  const handleInputChange = (event) => {
    setDownloaded(0);
    setImageData("")
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleCountrySelect = (country, name) => {
    setImageData("")
    setDownloaded(0);
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: country.callingCodes[0],
    }));
  };

  const handleDateChange = (date, name) => {
    setImageData("")
    setDownloaded(0);
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: moment(date).format("yyyy-MM-DD"),
    }));
  };


  const downloadImage = () => {
    saveAs(imageData, 'QR-code.jpg'); // Put your image URL here. 
    setDownloaded(1);
  }

  async function copyImg() {
    const img = await fetch(imageData);
    const imgBlob = await img.blob();
    try {
      await navigator.clipboard.write([
         new ClipboardItem({
             'image/png': imgBlob, // change image type accordingly
         })
       ]);
     } catch (error) {
         console.error(error);
     }
 }

  return (
    <>
     
      {/* {isContentLoading && (
        <div className="fixed inset-0 flex flex-col items-center justify-center bg-neutral-50 z-[100]">
          <div className="w-20 h-20 animate-spin">
            <div className="h-full w-full border-4 border-t-dark/50 border-b-dark/80 rounded-[50%]" />
          </div>
          <div className="text-center text-sm lg:text-xl font-medium text-gray-500 mt-8 mx-8 lg:mx-0">
            Please wait while while we process your request{" "}
            <span className="text-xl mx-1 inline-block animate-typing">.</span>
            <span className="text-xl mx-1 inline-block animate-typing">.</span>
            <span className="text-xl mx-1 inline-block animate-typing">.</span>
          </div>
        </div>
      )} */}
      
      <section id="contact" className="overflow-hidden py-16 md:py-20 lg:py-28">
        <div className="container">
          <div className="-mx-4 flex flex-wrap">
            <div className="w-full px-4 lg:w-7/12 xl:w-8/12">
              <div
                className="wow fadeInUp mt-6 mb-12 rounded-md bg-primary/[3%] py-11 px-8 dark:bg-dark sm:p-[55px] lg:mb-5 lg:px-8 xl:p-[55px]"
                data-wow-delay=".15s
              "
              >
                <h2 className="mb-3 text-2xl font-bold text-black dark:text-white sm:text-3xl lg:text-2xl xl:text-3xl">
                  Generate a QR for your Visiting Card
                </h2>
                <p className="mb-12 text-base font-medium" style={{color:"red"}}>
                  * Mandatory fields
                </p>
                <form onSubmit={handleSubmitTicket}>
                  <div className="-mx-4 flex flex-wrap">
                    <div className="w-full px-4 md:w-1/2">
                      <div className="mb-8">
                        <label
                          htmlFor="name"
                          className="mb-3 block text-sm font-medium text-dark dark:text-white"
                        >
                          Your First Name *
                        </label>
                        <input
                          type="text"
                          id="first_name"
                          name="first_name"
                          placeholder="Enter your first name here"
                          value={formData.first_name}
                          onChange={handleInputChange}
                          className="w-full rounded-md border border-transparent py-3 px-6 text-base text-body-color placeholder-body-color shadow-one outline-none focus:border-primary focus-visible:shadow-none dark:bg-[#242B51] dark:shadow-signUp"
                          required
                        />
                      </div>
                    </div>

                    <div className="w-full px-4 md:w-1/2">
                      <div className="mb-8">
                        <label
                          htmlFor="name"
                          className="mb-3 block text-sm font-medium text-dark dark:text-white"
                        >
                          Your Last Name *
                        </label>
                        <input
                          type="text"
                          id="name"
                          name="last_name"
                          placeholder="Enter your last name here"
                          value={formData.last_name}
                          onChange={handleInputChange}
                          className="w-full rounded-md border border-transparent py-3 px-6 text-base text-body-color placeholder-body-color shadow-one outline-none focus:border-primary focus-visible:shadow-none dark:bg-[#242B51] dark:shadow-signUp"
                          required
                        />
                      </div>
                    </div>

                    <div className="-mx-4 flex flex-wrap px-8"> 
                      <div className="w-full md:w-1/3 col">
                    <label
                          htmlFor="dropdown"
                          className="mb-3 block text-sm font-medium text-dark dark:text-white"
                        >
                         Country&nbsp;Code
                        </label>
                        <ReactCountryDropdown                          
                          defaultCountry="IN"
                          onSelect={(country) => {
                            handleCountrySelect(country, 'country_code');
                          }}
                        />
                    </div>
                    <div className="w-full md:w-2/3 col" >
                      <div className="mb-8">
                        <label
                          htmlFor="mobile_number"
                          className="mb-3 block text-sm font-medium text-dark dark:text-white"
                        >
                          Your Phone No. * 
                        </label>
                        <input
                          type="tel"
                          id="mobile_number"
                          name="mobile_number"
                          placeholder="Enter your phone number here"
                          value={formData.mobile_number}
                          onChange={handleInputChange}
                          className="w-full rounded-md border border-transparent py-3 px-6 text-base text-body-color placeholder-body-color shadow-one outline-none focus:border-primary focus-visible:shadow-none dark:bg-[#242B51] dark:shadow-signUp"
                          required
                        />
                      </div>
                    </div>
                    </div>
                    
                    <div className="-mx-4 flex flex-wrap px-12"> 
                      <div className="w-full md:w-1/3 col">
                    <label
                          htmlFor="text"
                          className="mb-3 block text-sm font-medium text-dark dark:text-white"
                        >
                         Country&nbsp;Code
                        </label>
                        <ReactCountryDropdown
                          
                          defaultCountry="IN"
                          onSelect={(country) => {
                            handleCountrySelect(country, 'alt_country_code');
                          }}
                          // (country) => setCode2(country.callingCodes)
                        />
                    </div>
                    <div className="w-full md:w-2/3 col" >
                      <div className="mb-8">
                        <label
                          htmlFor="alt_mobile_number"
                          className="mb-3 block text-sm font-medium text-dark dark:text-white"
                        >
                          Your Alternate Phone No. 
                        </label>
                        <input
                          type="tel"
                          id="alt_mobile_number"
                          name="alt_mobile_number"
                          placeholder="Enter alternate phone no. here"
                          value={formData.alt_mobile_number}
                          onChange={handleInputChange}
                          className="w-full rounded-md border border-transparent py-3 px-6 text-base text-body-color placeholder-body-color shadow-one outline-none focus:border-primary focus-visible:shadow-none dark:bg-[#242B51] dark:shadow-signUp"
                          // required
                        />
                      </div>
                    </div>
                    </div>

                   
                    <div className="w-full px-4 md:w-1/2">
                      <div className="mb-8">
                        <label
                          htmlFor="email"
                          className="mb-3 block text-sm font-medium text-dark dark:text-white"
                        >
                          Your Email ID
                        </label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          placeholder="Enter your email ID here"
                          value={formData.email}
                          onChange={handleInputChange}
                          className="w-full rounded-md border border-transparent py-3 px-6 text-base text-body-color placeholder-body-color shadow-one outline-none focus:border-primary focus-visible:shadow-none dark:bg-[#242B51] dark:shadow-signUp"
                          // // required
                        />
                      </div>
                    </div>
                    <div className="w-full px-4 md:w-1/2">
                      <div className="mb-8">
                        <label
                          htmlFor="email"
                          className="mb-3 block text-sm font-medium text-dark dark:text-white"
                        >
                          Your Alternate Email ID
                        </label>
                        <input
                          type="email"
                          id="alt_email"
                          name="alt_email"
                          placeholder="Enter your alternate email ID here"
                          value={formData.alt_email}
                          onChange={handleInputChange}
                          className="w-full rounded-md border border-transparent py-3 px-6 text-base text-body-color placeholder-body-color shadow-one outline-none focus:border-primary focus-visible:shadow-none dark:bg-[#242B51] dark:shadow-signUp"
                          // // required
                        />
                      </div>
                    </div>
                   

                    <div className="w-full px-4 md:w-1/2">
                      <div className="mb-8">
                        <label
                          htmlFor="company"
                          className="mb-3 block text-sm font-medium text-dark dark:text-white"
                        >
                          Your Company Name
                        </label>
                        <input
                          id="company"
                          name="organization_name"
                          
                          placeholder="Enter your company name here"
                          value={formData.organization_name}
                          onChange={handleInputChange}
                          className="w-full resize-none rounded-md border border-transparent py-3 px-6 text-base text-body-color placeholder-body-color shadow-one outline-none focus:border-primary focus-visible:shadow-none dark:bg-[#242B51] dark:shadow-signUp"
                          // // required
                        ></input>
                      </div>
                    </div>

                    <div className="w-full px-4 md:w-1/2">
                    <div className="mb-8">
                        <label
                          htmlFor="website"
                          className="mb-3 block text-sm font-medium text-dark dark:text-white"
                        >
                          Company Website
                        </label>
                        <input
                          type="text"
                          id="website"
                          name="website"
                          placeholder="Enter your company website here"
                          value={formData.website}
                          onChange={handleInputChange}
                          className="w-full rounded-md border border-transparent py-3 px-6 text-base text-body-color placeholder-body-color shadow-one outline-none focus:border-primary focus-visible:shadow-none dark:bg-[#242B51] dark:shadow-signUp"
                          // // required
                        />
                      </div>
                    </div>

                    <div className="w-full px-4 md:w-1/2">
                      <div className="mb-8">
                        <label
                          htmlFor="address"
                          className="mb-3 block text-sm font-medium text-dark dark:text-white"
                        >
                          Your Official Address
                        </label>
                        <textarea
                          id="address"
                          name="work_address"
                          rows={5}
                          placeholder="Enter your official address here"
                          value={formData.work_address}
                          onChange={handleInputChange}
                          className="w-full resize-none rounded-md border border-transparent py-3 px-6 text-base text-body-color placeholder-body-color shadow-one outline-none focus:border-primary focus-visible:shadow-none dark:bg-[#242B51] dark:shadow-signUp"
                          // // required
                        ></textarea>
                      </div>
                    </div>
                    <div className="w-full px-4 md:w-1/2">
                      <div className="mb-8">
                        <label
                          htmlFor="address"
                          className="mb-3 block text-sm font-medium text-dark dark:text-white"
                        >
                          Your Residential Address
                        </label>
                        <textarea
                          id="address"
                          name="home_address"
                          rows={5}
                          placeholder="Enter your residential address here"
                          value={formData.home_address}
                          onChange={handleInputChange}
                          className="w-full resize-none rounded-md border border-transparent py-3 px-6 text-base text-body-color placeholder-body-color shadow-one outline-none focus:border-primary focus-visible:shadow-none dark:bg-[#242B51] dark:shadow-signUp"
                          // // required
                        ></textarea>
                      </div>
                    </div>

                    <div className="w-full px-4 md:w-1/2">
                      <div className="mb-8">
                        <label
                          htmlFor="dob"
                          className="mb-3 block text-sm font-medium text-dark dark:text-white"
                        >
                          Your Date of Birth
                        </label>
                        <DatePicker name="dob" dateFormat={"yyyy-MM-dd"} placeholderText="YYYY-MM-DD" selected={formData.dob} onChange={(date) =>{handleDateChange(date, 'dob')}} className="w-full resize-none rounded-md border border-transparent py-3 px-6 text-base text-body-color placeholder-body-color shadow-one outline-none focus:border-primary focus-visible:shadow-none dark:bg-[#242B51] dark:shadow-signUp" />
                      </div>
                    </div>

                    <div className="w-full px-4 md:w-1/2">
                      <div className="mb-8">
                        <label
                          htmlFor="text"
                          className="mb-3 block text-sm font-medium text-dark dark:text-white"
                        >
                          Pronoun
                        </label>
                        {/* <Select options={pronouns} onChange={(e)=>setSelectedPronoun(e.value)}/> */}
                        <input
                          type="text"
                          id="pronouns"
                          name="pronouns"
                          placeholder="Eg. Male / Female / he / him / she / her"
                          value={formData.pronouns}
                          onChange={handleInputChange}
                          className="w-full rounded-md border border-transparent py-3 px-6 text-base text-body-color placeholder-body-color shadow-one outline-none focus:border-primary focus-visible:shadow-none dark:bg-[#242B51] dark:shadow-signUp"
                          // // required
                        />
                      </div>
                    </div>



                    <div className="w-full px-4 md:w-1/2">
                      <div className="mb-8">
                        <label
                          htmlFor="designation"
                          className="mb-3 block text-sm font-medium text-dark dark:text-white"
                        >
                          Your Designation
                        </label>
                        <input
                          id="designation"
                          name="designation"
                          // rows={1}
                          placeholder="Enter your Designation here"
                          value={formData.designation}
                          onChange={handleInputChange}
                          className="w-full resize-none rounded-md border border-transparent py-3 px-6 text-base text-body-color placeholder-body-color shadow-one outline-none focus:border-primary focus-visible:shadow-none dark:bg-[#242B51] dark:shadow-signUp"
                          // // required
                        ></input>
                      </div>
                    </div>
                    <div className="w-full px-4 md:w-1/2">
                      <div className="mb-8">
                        <label
                          htmlFor="text"
                          className="mb-3 block text-sm font-medium text-dark dark:text-white"
                        >
                          Your LinkedIn Profile
                        </label>
                        <input
                          id="linkedin_profile"
                          name="linkedin_profile"
                          // rows={1}
                          placeholder="Enter your LinkedIn profile here"
                          value={formData.linkedin_profile}
                          onChange={handleInputChange}
                          className="w-full resize-none rounded-md border border-transparent py-3 px-6 text-base text-body-color placeholder-body-color shadow-one outline-none focus:border-primary focus-visible:shadow-none dark:bg-[#242B51] dark:shadow-signUp"
                          // // required
                        ></input>
                      </div>
                    </div>
                    <div className="w-full px-4 md:w-1/2">
                      <div className="mb-8">
                        <label
                          htmlFor="twitter_profile"
                          className="mb-3 block text-sm font-medium text-dark dark:text-white"
                        >
                          Your Twitter Profile
                        </label>
                        <input
                          id="twitter_profile"
                          name="twitter_profile"
                          // rows={1}
                          placeholder="Enter your Twitter profile here"
                          value={formData.twitter_profile}
                          onChange={handleInputChange}
                          className="w-full resize-none rounded-md border border-transparent py-3 px-6 text-base text-body-color placeholder-body-color shadow-one outline-none focus:border-primary focus-visible:shadow-none dark:bg-[#242B51] dark:shadow-signUp"
                          // // required
                        ></input>
                      </div>
                    </div>
                    <div className="w-full px-4 md:w-1/2">
                      <div className="mb-8">
                        <label
                          htmlFor="fb_profile"
                          className="mb-3 block text-sm font-medium text-dark dark:text-white"
                        >
                          Your Facebook Profile
                        </label>
                        <input
                          id="fb_profile"
                          name="fb_profile"
                          // rows={1}
                          placeholder="Enter your Facebook profile here"
                          value={formData.fb_profile}
                          onChange={handleInputChange}
                          className="w-full resize-none rounded-md border border-transparent py-3 px-6 text-base text-body-color placeholder-body-color shadow-one outline-none focus:border-primary focus-visible:shadow-none dark:bg-[#242B51] dark:shadow-signUp"
                          // // required
                        ></input>
                      </div>
                    </div>
                    <div
              className="w-full px-4"
              style={{ color: "red", fontWeight: "bold" }}
            >
              *Please ensure all the entered details are correct before
              submitting.
            </div> &nbsp;
            {
              isContentLoading?(<><br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Loading...</>):(
                    <div className="w-full px-4">
                      <button
                        type="submit"
                        className="rounded-md bg-primary py-4 px-9 text-base font-medium text-white transition duration-300 ease-in-out hover:bg-opacity-80 hover:shadow-signUp"
                        // onClick={handleSubmit}
                      >
                        Submit
                      </button>
                    </div>
                    )
                  }
                  </div>
                </form>

                <div className="w-full px-12 mt-10">
              {imageData?(<>
              {/* {window.scrollTo({ top: 0 })} */}
              <div className="text-center">
              <img src={imageData}></img><br/>
                <div>
                  {/* <button className="rounded-md bg-primary py-2 px-5 text-base font-medium text-white transition duration-300 ease-in-out hover:bg-opacity-80 hover:shadow-signUp" onClick={copyImg}>Copy</button>&nbsp; */}
                  Download your QR code here! &nbsp;<br/>
                  <button className="rounded-md bg-primary py-2 px-5 text-base font-medium text-white transition duration-300 ease-in-out hover:bg-opacity-80 hover:shadow-signUp" onClick={downloadImage}>Download</button>&nbsp;<br/> <br/> 
                  
                  { downloaded?(<h3 className="w-full px-4" style={{color:"blue", fontWeight:"bold"}}>Your QR-code is downloaded.<br/> Search for <br/>  "QR-code.jpg" <br/> in your downloads folder. <br/> You may print, scan or share</h3>):(<div></div>)
                  }   
                </div>
              </div> 
              </>
              
            ):(<div></div>)}
            </div>
                {/* <div
              class="form-group"
              style={{ color: "red", fontWeight: "bold" }}
            >
              *Please ensure all the entered details are correct before
              submitting.
            </div> &nbsp;
                <div className="w-full px-4">
                      <button
                        // type="submit"
                        className="rounded-md bg-primary py-2 px-5 text-base font-medium text-white transition duration-300 ease-in-out hover:bg-opacity-80 hover:shadow-signUp"
                        onClick={handleSubmit}
                      >
                        Submit
                      </button>
                    </div> */}
                  {/* {
                    imageData?(<>Download your QR code here! &nbsp;
                    <button className="rounded-md bg-primary py-2 px-5 text-base font-medium text-white transition duration-300 ease-in-out hover:bg-opacity-80 hover:shadow-signUp" onClick={downloadImage}>Download</button>
                    </>
                    ):(<div></div>)
                  } */}
                    
              </div>
            </div>
            {/* <div className="w-full px-4 lg:w-5/12 xl:w-4/12" style={{marginTop:"50px"}}>
              {imageData?(<>
              {window.scrollTo({ top: 0 })}
              <div className="text-center">
              <img src={imageData}></img>
                <div>
                  <button className="rounded-md bg-primary py-2 px-5 text-base font-medium text-white transition duration-300 ease-in-out hover:bg-opacity-80 hover:shadow-signUp" onClick={copyImg}>Copy</button>&nbsp;
                  Download your QR code here! &nbsp;
                  <button className="rounded-md bg-primary py-2 px-5 text-base font-medium text-white transition duration-300 ease-in-out hover:bg-opacity-80 hover:shadow-signUp" onClick={downloadImage}>Download</button>&nbsp;<br/> <br/> 
                  
                  { downloaded?(<h3 className="w-full px-4" style={{color:"blue", fontWeight:"bold"}}>Your QR-code is downloaded.<br/> Search for <br/>  "QR-code.jpg" <br/> in your downloads folder. <br/> You may print, scan or share</h3>):(<div></div>)
                    
                 
                     }   </div>
              </div>
                
                
                
              </>
              
            ):(<div></div>)}
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default VCardComponent;
